import Vue from 'vue'
import { USAGE_TYPES_NAME } from './usageTypes'

const matchTranslate = (translate, data) =>
  data.reduce((result, currentItem) => {
    const findItem = translate.find(item => item.value === currentItem)

    if (findItem) {
      result.push(findItem)
    }

    return result
  }, [])

export default {
  getVouchers: async ({ commit }, params) => {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/promo-codes`, { params })

    return data
  },
  getVouchersByPromoCode: async ({ commit }, params) => {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/crm/promo-codes/${params.id}/get-orders`, {
      params,
    })

    return data
  },
  createVoucher: ({ commit, state }, params) => {
    return axios
      .post(`${process.env.VUE_APP_PROMO_CODE_SERVER}/${Vue.config.modules.crm.api.vouchers.all}`, {
        model_type: params.model_type,
        model_id: params.model_id,
        sum: parseInt(params.sum),
        expires_at: params?.expires_at || null,
      })
      .catch(error => {
        let errors = []

        for (const key in error?.response?.data) {
          const values = error.response.data[key]

          errors.push(...values)
        }

        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.loadingError,
          type: 'error',
          text:
            error.response.status !== 422
              ? 'Упс! Что-то пошло не так'
              : errors
                  .join('<br>')
                  .replace('model type', 'целевой тип')
                  .replace('model id', 'кому выдать')
                  .replace('sum', 'сумма'),
        })
      })
  },
  redeemVoucher: ({ commit, state }, code) => {
    return axios
      .delete(
        `${process.env.VUE_APP_PROMO_CODE_SERVER}/${Vue.config.modules.crm.api.vouchers.one.replace('$id', code)}`,
      )
      .then(() => {
        commit('removeVoucher', code)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.loadingError,
          type: 'error',
          text: error?.message || 'Упс! Что-то пошло не так',
        })
      })
  },
  // http://promo-codes-staging.pilki.com/api/v1/usage-types
  async getUsageTypes() {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/usage-types`)

    const usageTypesTranslate = [
      {
        value: USAGE_TYPES_NAME.unit,
        title: 'Студии',
      },
      {
        value: USAGE_TYPES_NAME.company,
        title: 'Компании',
      },
      {
        value: USAGE_TYPES_NAME.user,
        title: 'Клиенты',
      },
      {
        value: USAGE_TYPES_NAME.employer,
        title: 'Сотрудники',
      },
      {
        value: USAGE_TYPES_NAME.segment,
        title: 'Сегмент',
      },
      {
        value: USAGE_TYPES_NAME.all,
        title: 'Для всех у кого есть промокод',
      },
    ]
    return matchTranslate(usageTypesTranslate, data)
  },
  async getRedeemTypes() {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/redeem-types`)

    const usageTypesTranslate = [
      {
        value: 'SERVICE',
        title: 'Услуга',
      },
      {
        value: 'GOOD',
        title: 'Товар',
      },
      {
        value: 'SERVICE_OR_GOOD',
        title: 'Товар или услуга',
      },
      {
        value: 'MASTER_MONEY',
        title: 'Деньги сотруднику',
      },
    ]

    return matchTranslate(usageTypesTranslate, data)
  },

  async getPaymentTypes() {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/payment-types`)

    const paymentTypesTranslate = [
      {
        value: 'FIX',
        title: 'Фиксированная цена',
      },
      {
        value: 'PERCENT',
        title: 'Процент',
      },
    ]

    return matchTranslate(paymentTypesTranslate, data)
  },

  async getPromoCodeDurationTypes() {
    const {
      data: { data },
    } = await axios.get(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/duration-types`)

    const promoCodeDurationTypesTranslate = [
      {
        value: 'TIME',
        title: 'По времени',
      },
      {
        value: 'MAX_ACTIVATIONS_COUNT',
        title: 'Кол-ву активаций',
      },
      {
        value: 'USER_ACTIVATIONS_COUNT',
        title: 'Кол-ву активаций пользователями',
      },
      {
        value: 'UNIT',
        title: 'По студии',
      },
      {
        value: 'EMPLOYER_PRICE_CATEGORY',
        title: 'Ценовые категории мастеров',
      },
      {
        value: 'WEEKLY_SCHEDULE',
        title: 'По расписанию на неделе',
      },
    ]

    return matchTranslate(promoCodeDurationTypesTranslate, data)
  },

  createPromoCodeRest({ commit }, params) {
    return axios.post(`${process.env.VUE_APP_PROMO_CODE_SERVER}/api/v1/promo-codes`, params)
  },
}
